<app-title-section></app-title-section>

<div class="card " style="margin-left: 15px; margin-right: 15px;height: calc(100vh - 140px); display: flex; flex-direction: column;">
    <!-- Tabs -->
    <div class="p-1 mt-1" style="margin-left: 20px">
        <button (click)="retour() " class="unstyled-btn ">
            <i data-feather="arrow-left" [size]="18"> </i>
        </button>
        Retour
    </div>

<app-filtre-date (dateFilterChange)="onDateFilterChange($event)"></app-filtre-date>


    <div class="d-flex align-items-center flex-wrap" style="margin-top: 24px; margin-left: 44px; margin-right: 24px; gap: 12px;">
        <div class="d-flex align-items-center flex-wrap" style="gap: 12px;">
            <div class="input-group form-password-toggle d-flex" style="width: 300px;">
                <input
                        type="text"
                        class="form-control"
                        placeholder="Recherche par mot clé"
                        aria-label="Search..."
                        aria-describedby="basic-addon-search1"
                        [(ngModel)]="searchTerm" (ngModelChange)="onSearch()"
                />
                <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon-search1" style="color: black;"><i data-feather="search" [size]="20"></i></span>
                </div>
            </div>
            <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()">
                <span data-feather="filter"></span>
            </button>
            <!-- Badges de filtres actifs -->
            <div class="d-flex align-items-center flex-wrap" style="gap: 8px;" *ngIf="getActiveFilters().length > 0">
                <div *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey" class="filter-chip">
                    <span class="filter-chip-label">{{ filter.label }}:</span>
                    <span class="filter-chip-value">{{ filter.value }}</span>
                    <button type="button" class="filter-chip-close" (click)="removeFilter(filter.key, $event); $event.stopPropagation(); $event.preventDefault()" aria-label="Supprimer le filtre">
                        <i data-feather="x" [size]="14"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- Filter Panel -->
        <div #filterPanel class="card filter-sidebar length" *ngIf="showFilter" style="width: 320px;max-height: 450px">
            <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
                <h4 class="card-title mb-0">Filtres</h4>
                <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                    X <i class="bx bx-x"></i>
                </button>
            </div>
            <div class="card-body d-flex flex-column " style="height: 360px; box-shadow: 2px 4px 8px rgba(47, 43, 61, 0.14);">
                <div class="flex-grow-1 overflow-auto p-1">
                    <!-- Banque -->
                    <div class="mb-1">
                        <label class="form-label">Banque</label>
                        <ng-select 
                            class="filter-ng-select"
                            [items]="banques"
                            bindLabel="nom"
                            bindValue="id"
                            [searchable]="true"
                            [clearable]="true"
                            placeholder="Choisissez une banque"
                            [(ngModel)]="filters.banque_id"
                            (change)="updateFilteredData()">
                        </ng-select>
                    </div>

                    <!-- Type d'opération -->
                    <div class="mb-1">
                        <label class="form-label">Type d'opération</label>
                        <ng-select 
                            class="filter-ng-select"
                            [items]="[
                                {value: 'depense', label: 'Dépense'},
                                {value: 'recette', label: 'Recette'},
                                {value: 'remise_banque', label: 'Remise en banque'},
                                {value: 'operation_manuelle', label: 'Opération manuelle'},
                                {value: 'avance_espece', label: 'Avance en espèce'}
                            ]"
                            bindLabel="label"
                            bindValue="value"
                            [searchable]="false"
                            [clearable]="true"
                            placeholder="Choisissez un type"
                            [(ngModel)]="filters.type_operation"
                            (change)="updateFilteredData()">
                        </ng-select>
                    </div>

                    <!-- Type de transaction -->
                    <div class="mb-1">
                        <label class="form-label">Type de transaction</label>
                        <ng-select 
                            class="filter-ng-select"
                            [items]="[
                                {value: 'paiement', label: 'Paiement'},
                                {value: 'remise_banque', label: 'Remise en banque'},
                                {value: 'operation_diverse', label: 'Opération diverse'},
                                {value: 'depense', label: 'Dépense'},
                                {value: 'annulation', label: 'Annulation'}
                            ]"
                            bindLabel="label"
                            bindValue="value"
                            [searchable]="false"
                            [clearable]="true"
                            placeholder="Choisissez un type"
                            [(ngModel)]="filters.type_transaction"
                            (change)="updateFilteredData()">
                        </ng-select>
                    </div>

                    <!-- Catégories -->
                    <div class="mb-1">
                        <label class="form-label">Catégories</label>
                        <ng-select 
                            class="filter-ng-select"
                            [items]="categories"
                            bindLabel="nom"
                            bindValue="id"
                            [searchable]="true"
                            [clearable]="true"
                            placeholder="Choisissez une catégorie"
                            [(ngModel)]="filters.categorie_id"
                            (change)="updateFilteredData()">
                        </ng-select>
                    </div>

                    <!-- Type de paiement -->
                    <div class="mb-1">
                        <label class="form-label">Type de paiement</label>
                        <ng-select 
                            class="filter-ng-select"
                            [items]="[
                                {value: 'cheque', label: 'Chèque'},
                                {value: 'traite', label: 'Traite'},
                                {value: 'espece', label: 'Espèce'}
                            ]"
                            bindLabel="label"
                            bindValue="value"
                            [searchable]="false"
                            [clearable]="true"
                            placeholder="Choisissez un type"
                            [(ngModel)]="filters.type_paiement"
                            (change)="updateFilteredData()">
                        </ng-select>
                    </div>

                    <!-- Montant -->
                    <div class="mb-1">
                        <label class="form-label">Montant</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control" style="width: 60px; margin-right: 8px;" [(ngModel)]="filters.operator">
                                <option value="=">=</option>
                                <option value=">">></option>
                                <option value="<"><</option>
                            </select>
                            <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.chiffre_aff" placeholder="Montant" />
                        </div>
                    </div>

                    <!-- Date -->
                    <div class="mb-1">
                        <label class="form-label">Date</label>
                        <div class="d-flex w-100 gap-2">
                            <input 
                                type="text" 
                                class="form-control" 
                                placeholder="du" 
                                [(ngModel)]="filters.date_du"
                                #dateDuInput
                                (change)="updateFilteredData()"
                                style="flex: 1;" />
                            <input 
                                type="text" 
                                class="form-control" 
                                placeholder="jusqu'a" 
                                [(ngModel)]="filters.date_jusqua"
                                #dateJusquaInput
                                (change)="updateFilteredData()"
                                style="flex: 1;" />
                        </div>
                    </div>
                </div>
                <div class="pt-2 d-flex justify-content-end gap-1">
                    <button class="btn btn-outline-secondary w-40" (click)="resetFilters()" style="margin-right: 15px;">Réinitialiser</button>
                    <button class="btn btn-primary w-40" (click)="applyFilters()">Appliquer</button>
                </div>
            </div>
        </div>

    </div>
    <div style=" border-bottom: 1px solid #eee; margin-top: 24px; margin-bottom: 10px"></div>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead class=" custom-thead" >
            <tr  class="align-middle" >
                <th>Date</th>
                <th>Type</th>
                <th>Numéro</th>
                <th>Document</th>
                <th>Débit / Dépense</th>
                <th>Crédit</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="isLoading">
                <td colspan="7" class="text-center">Chargement...</td>
            </tr>
            <tr *ngIf="!isLoading && paginatedData.length === 0">
                <td colspan="7" class="text-center">Aucune donnée disponible</td>
            </tr>
            <tr *ngFor="let item of paginatedData">
                <td [size]="15">{{ item.date }}</td>
                <td [size]="15">{{ item.type }}</td>
                <td [size]="15">{{ item.numero }}</td>
                <td [size]="15">{{ item.document }}</td>
                <td [size]="15"> <span class="debit">{{ item.debit }} </span> </td>
                <td [size]="15" > <span class="credit">{{ item.credit }} </span></td>
                <td>
                    <div class="d-flex align-items-center action-icon">
                        <button class="unstyled-btn" (click)="openArchiveModal(modalVC, item)">
                            <i data-feather="eye" [size]="20" class="cursor-pointer"></i>
                        </button>
                    </div>
                    <ng-template #modalVC let-modal >
                        <div class="modal-header p-0" style="background-color: transparent;">
                            <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="" style="margin: 62px ; margin-top: 51px" >
                            <div class="flex-grow-1  ">
                                <h2 class="modal-title text-center" style="font-size: 24px; font-weight: 500; margin-left: 60px;margin-right: 60px; color: #2F2B3DE5">
                                    {{ selectedItem?.remise ? 'Détails de la remise' : (selectedItem?.paiement ? 'Détails du paiement' : 'Détails de l\'opération') }}
                                </h2>
                            </div>
                            <div class="flex-grow-1">
                                <hr class="section-line" style="border: 1px solid #134AD3">
                                <table class=" custom-table" *ngIf="selectedItem">
                                    <!-- Si c'est une remise, afficher les détails de la remise -->
                                    <ng-container *ngIf="selectedItem.remise">
                                        <tr>
                                            <td class="label">Référence</td>
                                            <td>{{ selectedItem.tresorerie?.document_reference || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Numéro de remise</td>
                                            <td>{{ getRemiseDetails()?.numero_remise || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Date de remise</td>
                                            <td>{{ getRemiseDetails()?.date_banque || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Note</td>
                                            <td>{{ getRemiseDetails()?.note || '--' }}</td>
                                        </tr>
                                    </ng-container>
                                    <!-- Si c'est un paiement, afficher les détails du paiement -->
                                    <ng-container *ngIf="selectedItem.paiement && !selectedItem.remise">
                                        <tr>
                                            <td class="label">Référence</td>
                                            <td>{{ selectedItem.document || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Date de paiement</td>
                                            <td>{{ selectedItem.date || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Type de paiement</td>
                                            <td>{{ selectedItem.type || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Numéro</td>
                                            <td>{{ selectedItem.numero || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Montant</td>
                                            <td>{{ selectedItem.debit || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Référence paiement</td>
                                            <td>{{ selectedItem.paiement?.reference || '--' }}</td>
                                        </tr>
                                    </ng-container>
                                    <!-- Sinon, afficher les détails de l'opération de trésorerie -->
                                    <ng-container *ngIf="!selectedItem.remise && !selectedItem.paiement">
                                        <tr>
                                            <td class="label">Référence</td>
                                            <td>{{ selectedItem.tresorerie?.document_reference || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Date d'opération</td>
                                            <td>{{ selectedItem.date || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Type d'opération</td>
                                            <td>{{ selectedItem.type || '--' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Montant</td>
                                            <td>{{ selectedItem.debit !== '--' ? selectedItem.debit : selectedItem.credit }}</td>
                                        </tr>
                                        <tr>
                                            <td class="label">Description</td>
                                            <td>{{ selectedItem.tresorerie?.description || '--' }}</td>
                                        </tr>
                                    </ng-container>
                                </table>
                            </div>
                        </div>
                    </ng-template>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="row mt-3">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center" style="font-size: 15px;">
                    Afficher
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="updatePagination()">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>

                </label>
            </div>
        </div>
        <div class="col-md-6 text-end">
            <div class="d-flex flex-wrap justify-content-end gap-2">
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«</div>
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(currentPage - 1)">‹</div>
                <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage" (click)="changePage(page)">{{ page }}</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(currentPage + 1)">›</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(totalPages)">»</div>
            </div>
        </div>
    </div>
</div>

<app-save #save></app-save>
